<template>

    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="评审名称" name="projectReviewName">
                <a-input v-model:value="searchForm.projectReviewName" placeholder="请输入评审名称"/>
            </a-form-item>
            <a-form-item label="评审地点" name="reviewPlace">
                <a-input v-model:value="searchForm.reviewPlace" placeholder="请输入评审地点"/>
            </a-form-item>

            <a-form-item label="评审时间" name="reviewPlace">
                <RangePicker v-model:value="dateTime"
                             @change="changeTime"
                             placeholder="请选择时间"/>
            </a-form-item>
            <a-form-item style="margin-right: 0">
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>

        <a-alert message="必须3个工作日内对完善资料进行确认" type="warning" show-icon style="margin-bottom: 8px" />
        <a-table :columns="columns" :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
            <template #projectReviewName="{ record, text }">
                <a href="#" @click="showDetail(record)">{{ text }}</a>
            </template>
            <template #meetingMinutes="{ record }">
                <FileUpload v-model:value="record.meetingMinutes" :show-btn="false" disabled></FileUpload>
            </template>
            <template #applicationAttachment="{ record }">
                <FileUpload v-model:value="record.applicationAttachment" :show-btn="false" disabled></FileUpload>
            </template>
            <template #reviewStatus="{ record, text }">
                <div style="cursor: pointer" @click="showProcessPanel(record)">
                    <a-tag v-if="text===2" style="border-color: #2db7f5; color: #2db7f5">待确认</a-tag>
                    <a-tag v-if="text===0" style="border-color: #FF0000; color: #FF0000">驳回</a-tag>
                    <a-tag v-if="text===1" style="border-color: #008000; color: #008000">通过</a-tag>
<!--                    <a-tag v-if="text==='-1'" style="border-color: #008000; color: #008000">已报废</a-tag>-->
                </div>
            </template>
            <template #action="{ record }">
                <div class="table-row-operations">
                    <a v-if="record.auditResult===2" @click="onConfirm(record)">确认</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <ConfirmModal ref="confirm" @finish="loadData"></ConfirmModal>
    <Detail ref="detail"></Detail>
    <ProcessPanel ref="panel"></ProcessPanel>
</template>

<script>

import {dictMixin, tableListMixin} from "@/mixins";

import {application} from "@/api/projectReviewService";

import FileUpload from "@/components/form/upload/FileUpload";
import ConfirmModal from "./components/ConfirmModal";
import Detail from "@/views/sys/expert/registered/components/Detail";
import ProcessPanel from "@/views/sys/application/resultAudit/components/ProcessPanel";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {
        title: "项目名称",
        dataIndex: "applicationName",
        key: "applicationName",
        width:"220px",
        ellipsis: true,
        slots: {customRender: "projectReviewName"}
    },
    {title: "审核状态", dataIndex: "auditResult", key: "auditResult", slots: {customRender: "reviewStatus"}},
    {title: "评审时间",width:"150px", dataIndex: "reviewTime", key: "reviewTime"},
    {title: "评审地点", dataIndex: "reviewPlace", ellipsis: true, key: "reviewPlace",width:"200px"},
    {title: "确认次数", dataIndex: "batch", key: "batch"},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin, dictMixin],
    components: {
        Detail,
        ProcessPanel,
        FileUpload,
        ConfirmModal
    },
    data() {
        return {
            columns,
            queryParam: {},
            listUrl: application.myAppendAudit,
            listKeyField: "id",
            deleteUrl: "",
            dateTime:[]
        }
    },
    methods: {
        onReset(){
            this.dateTime=[]
            this.$refs.searchForm.resetFields();
            this.queryParam = {};
            this.searchForm = {}
            this.loadData(1);
        },
        changeTime(time) {
            this.queryParam.startTime = time[0]
            this.queryParam.endTime = time[1]
        },
        showProcessPanel(row){
            if (row.reviewStatus==='-1'){
                return
            }
            let data = {...row}
            // console.log(data,"aaaaaaaaaa")
            const refEle = this.$refs['panel'];
            refEle.reviewId = data.applicationId
            refEle.reviewStatus = data.reviewStatus
            refEle.visible = true
        },
        showDetail(row){
            console.log(row.applicationId)
            this.getAction({
                url:application.detail,
                params:{
                    id: row.applicationId
                }
            }).then(resp=>{
                this.onShowModal("detail", resp)
            })
        },
        onConfirm(record){
            const refEle = this.$refs["confirm"];
            refEle.form = {
                batch: record.batch,
                applicationId: record.applicationId,
                id:record.id,
                fileStr : record.appendFiles
            };
            refEle.visible = true;
        }
    }
}
</script>

<style scoped>
.table-search .ant-input, .table-search .ant-select {
    width: 147px !important;
}
</style>
